import React from 'react'
import AppDevelopmentTypePage from './AppDevelopmentTypePage'
import { appDevelopmentTypeContent } from './appDevelopmentTypeContent'

const AugmentedRealityAppDevelopment = () => <AppDevelopmentTypePage content={appDevelopmentTypeContent.ar} />

export default AugmentedRealityAppDevelopment
